import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DICTIONARY_PATHS } from '../../constants/dictionary-paths';
import { usePermission } from '../../core';
import { useDictionaryList } from '../../hooks';
import InvalidPermissionsDialog from '../../components/invalid-permissions-dialog/InvalidPermissionsDialog';
import { LandingPageWrapper } from 'components';
import { getColumns, tableHeight } from './dicitionary.helper';
import { DictionariesEmptyStateImg } from '../../assets';

export const Dictionaries = (): React.JSX.Element => {
    const navigate = useNavigate();
    const { hasPermissions } = usePermission();
    const { data: dictionaries, isLoading } = useDictionaryList();
    const columns = getColumns();
    const [displayPermissionDialog, setDisplayPermissionDialog] =
        useState(false);

    const handleRowClick = (row: any): void => {
        const filData = dictionaries?.data.filter(
            (fil) => `${fil?.name}_${fil?.description}` === row?.id
        );
        navigate(`${DICTIONARY_PATHS.LANDING_PAGE}/${filData?.[0]?.name}`);
    };

    const handleAdd = (): void => {
        const permission = hasPermissions('createMetadata');
        if (permission) {
            navigate(DICTIONARY_PATHS.CREATE_NEW_DICTIONARY_VIEW);
        } else {
            setDisplayPermissionDialog(true);
        }
    };

    const handleDialogClose = (): void => {
        setDisplayPermissionDialog(false);
    };

    return (
        <>
            <LandingPageWrapper
                title={'Dictionaries'}
                showAddButton={true}
                onAddButtonClick={handleAdd}
                tableData={dictionaries?.data}
                isLoading={isLoading}
                columns={columns}
                getRowId={(row: any): string =>
                    `${row.name}_${row.description}`
                }
                onRowClick={(row): void => {
                    handleRowClick(row);
                }}
                paginationPageSizeOptions={[25, 50, 100]}
                paginationPageSize={25}
                tableHeight={tableHeight}
                emptyStateIcon={DictionariesEmptyStateImg}
                emptyStateBodyMessage={
                    'Add a new dictionary using the button at the top right of the screen.'
                }
                sortModel={[{ field: 'name', sort: 'asc' }]}
            />
            {displayPermissionDialog && (
                <InvalidPermissionsDialog
                    open={displayPermissionDialog}
                    onClose={handleDialogClose}
                />
            )}
        </>
    );
};
